
const windowSize = {
    smallWidthSize: 1300,
    iconWidthSize: 950
}


export { windowSize }
